import { MessageCircle } from "lucide-react";

// Floating WhatsApp chat button that follows the user while scrolling.
// Sits above the mobile sticky CTA bar on small screens.
export const FloatingContact = ({ config = {} }) => {
  const href = config.whatsapp && config.whatsapp !== "#" ? config.whatsapp : null;
  if (!href) return null;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat sa WhatsApp"
      className="group fixed bottom-20 right-4 z-40 flex items-center gap-2 rounded-full bg-[hsl(152_60%_36%)] py-3 pl-3 pr-4 text-white shadow-[0_10px_30px_-8px_rgba(16,94,68,0.6)] transition-transform duration-200 hover:scale-105 hover:bg-[hsl(152_60%_32%)] lg:bottom-6 lg:right-6"
    >
      <span className="relative flex h-6 w-6 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-60" />
        <MessageCircle className="relative h-6 w-6" />
      </span>
      <span className="text-sm font-semibold">Chat</span>
    </a>
  );
};
